import * as XLSX from "xlsx";

export default function DownloadExcel(data, deleteColumnsName, fileName, transformations=[]) {
 
  const addData = data.map((report, index) => {
    let newReport = {
      SN: index + 1,
      ...report,
    };

    transformations.forEach((transformation) => {
      if (transformation.type === 'add') {
        newReport[transformation.newKey] = transformation.value;
      } else if (transformation.type === 'rename' && newReport[transformation.oldKey]) {
        newReport[transformation.newKey] = newReport[transformation.oldKey];
        delete newReport[transformation.oldKey];
      }
    });

    return newReport;
  });

  const dataFiltered = deleteColumnsForDownload(addData, deleteColumnsName);

  const worksheet = XLSX.utils.json_to_sheet(dataFiltered);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

const deleteColumnsForDownload = (filteredData, deleteColumnsName) => {
  return filteredData.map((newData) => {
    deleteColumnsName.forEach((column) => {
      delete newData[column];
    });
    return newData;
  });
};
